module.exports = __webpack_public_path__ + "TRUONGadd.10fe1dad.png";